module.exports = __webpack_public_path__ + "static/media/kv-all-casino.5b7457f4.jpeg";